import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useTheme } from "@mui/material";

interface Props {
  top_workers: null | any[];
}

const EmployeeWorkChart = (props: Props) => {
  const theme = useTheme();

  const [employeesNames, setEmployeesNames] = useState<string[]>();
  const [workedHours, setWorkedHours] = useState<string[]>();

  useEffect(() => {
    if (props.top_workers) {
      let hoursArr: any = [];
      let usernamesArr: any = [];
      props.top_workers.forEach((item) => {
        usernamesArr.push(item.name);
        hoursArr.push(item.total_minutes);
      });
      setEmployeesNames(usernamesArr);
      setWorkedHours(hoursArr);
    }
  }, [props.top_workers]);

  let options = {
    chart: {
      type: "column",
      backgroundColor: theme?.palette?.background?.paper,
    },
    accessibility: {
      description: "Top Employees details",
    },
    title: {
      text: "Employee Work Time",
      style: {
        color: theme?.palette?.text?.secondary,
      },
    },
    // subtitle: {
    //   text:
    //     'Source: <a href="https://fas.org/issues/nuclear-weapons/status-world-nuclear-forces/" ' +
    //     'target="_blank">FAS</a>'
    // },
    xAxis: {
      // allowDecimals: false,
      categories: employeesNames,
      gridLineWidth: 0,
      // labels: {
      //   formatter: function () {
      //     console.log(this, "this value");
      //     return this.value;
      //   }
      // },
      // accessibility: {
      //   rangeDescription: "Range: 2021 to 2022."
      // }
    },
    yAxis: {
      title: {
        text: "Work time in hours",
      },
      borderWidth: 20,
      gridLineWidth: 0,

      // labels: {
      //   formatter: function () {
      //     return this.value;
      //   },
      // },
    },
    tooltip: {
      // pointFormat: "{series.name} <b>{point.y:,.0f}</b><br/> in {point.x}",
      pointFormat: "<b>{point.y:,.0f}</b> hours<br/>",
    },
    plotOptions: {
      area: {
        borderWidth: "20",

        pointStart: 0,

        color: "rgb(207,232,252)",
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    series: [
      {
        name: "Employees",
        data: workedHours,
      },
    ],
  };
  return (
    <div className="chart_container">
      <div className="subject_chart_container">
        <HighchartsReact
          className="chart"
          highcharts={Highcharts}
          options={options}
        />
      </div>
    </div>
  );
};

export default EmployeeWorkChart;
